"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _colors = require("../../../config/colors");

var _config = require("../../../config/config");

var DEFAULT_FIELD_NAMES = ['New Text Field', 'New Number Field', 'New Date Field', 'New Dropdown Field', 'New Signature Field', 'New Checkbox Field', 'New Radio Field'];

var FieldName = function FieldName(_ref) {
  var name = _ref.name,
      handleChange = _ref.handleChange,
      handleFocus = _ref.handleFocus,
      focusActive = _ref.focusActive,
      errorMessages = _ref.errorMessages,
      fieldNameClicked = _ref.fieldNameClicked;

  var fieldNameValidation = function fieldNameValidation() {
    if (errorMessages && !name) {
      return true;
    }

    if (name) {
      return false;
    }

    if (!fieldNameClicked && !name) {
      return false;
    }

    return true;
  }; // Always ensure name is a string


  var nameValue = typeof name === 'string' ? name : String(name || '');

  var handleFieldFocus = function handleFieldFocus(e) {
    // Prevent default to avoid any form submission
    e.preventDefault(); // First call handleFocus to set up any UI state

    handleFocus(e); // Then check if we need to clear the default name

    if (DEFAULT_FIELD_NAMES.includes(nameValue)) {
      // Use setTimeout to ensure this happens after the focus handling
      setTimeout(function () {
        // Only update the name field without affecting other properties
        handleChange({
          target: {
            name: 'name',
            value: ''
          },
          // Prevent handleChange from accidentally removing data property
          preserveData: true
        });
      }, 0);
    }
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Group, {
      style: {
        marginBottom: _config.SIDEBAR_INPUTS_MARGIN,
        marginLeft: '0px'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        fontSize: 14,
        fontWeight: 300,
        color: errorMessages && !nameValue ? '#dc3545' : ''
      }
    }, "Field Name"),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Label, {
      style: {
        color: 'red',
        marginLeft: 3
      }
    }, " * "),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup, {
      className: "mb-3"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      id: "basic-url-name",
      isInvalid: fieldNameValidation(),
      required: true,
      "aria-describedby": "basic-addon3",
      name: "name",
      onChange: function onChange(e) {
        // Prevent default to stop any form submission
        e.preventDefault();
        handleChange(e);
      },
      value: nameValue,
      "data-cy": "question-name-input",
      placeholder: _config.DEFAULT_PLACE_HOLDER_TEXT,
      onFocus: handleFieldFocus,
      onBlur: function onBlur(e) {
        e.preventDefault();
        e.target.placeholder = _config.DEFAULT_PLACE_HOLDER_TEXT;
      },
      style: {
        backgroundColor: _colors.SIDEBAR_INPUTS_BACKGROUND_COLOR,
        fontSize: 14,
        fontWeight: 300
      },
      className: focusActive.name ? 'focusInputActive' : 'focusInput'
    }),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
      type: "invalid"
    }, _config.FIELD_NAME_FEEDBACK)))
  );
};

FieldName.defaultProps = {
  name: '',
  errorMessages: false
};
FieldName.propTypes = process.env.NODE_ENV !== "production" ? {
  name: _propTypes["default"].string,
  handleChange: _propTypes["default"].func.isRequired,
  handleFocus: _propTypes["default"].func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  focusActive: _propTypes["default"].object.isRequired,
  errorMessages: _propTypes["default"].bool,
  fieldNameClicked: _propTypes["default"].bool.isRequired
} : {};

var _default = exports["default"] = FieldName;